import Loader from '@/components/common/Loader'
import { useNavigationStore } from '@/stores/useNavigationStore'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

const NewPermitsPage = lazy(async () => {
  const module = await import(
    '@/features/city-clerk/dashboard-permit-tracking/pages/NewPermitsPage/NewPermitsPage'
  )
  return { default: module.default }
})

export const Route = createFileRoute(
  '/(app)/city-clerk/$id/projects/$projectId/permits',
)({
  beforeLoad: ({ context }) => {
    if (context.auth.loading) return
    if (!context.auth.userInfo?.uiCapabilities?.projectPermitsView) {
      throw redirect({ to: '/access-denied' })
    }
  },
  component: ProjectPermitsPage,
})

function ProjectPermitsPage() {
  const from = useNavigationStore((state) => state.from)
  return (
    <Suspense
      fallback={
        <div className="h-page bg-(--color-surface) flex items-center justify-center z-9999">
          <Loader size="lg" />
        </div>
      }
    >
      {from === 'projects' ? (
        <NewPermitsPage toDashboard={true} />
      ) : (
        <NewPermitsPage toDashboard={false} />
      )}
    </Suspense>
  )
}
